import React from 'react'

const Footer = () => {
  return (<footer>
    <div>
        <h1>Henmai</h1>
        <p>@All rights reserved.</p>
    </div>
    <div>
        <h5>Follow Us</h5>
        <div>
            <a href="https://youtube.com/"target={"blank"}>Youtube</a>
            <a href="https://instagram.com/"target={"blank"}>Instagram</a>
            <a href="https://twitter.com/"target={"blank"}>Twitter</a>
        </div>
    </div>
  </footer>
  )
}

export default Footer